// import React, { useState, useEffect, useRef } from 'react';
// import { Menu, X, ChevronDown, Search, ArrowRight } from 'lucide-react';

// const Navbar = () => {
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [isScrolled, setIsScrolled] = useState(false);
//   const [isSearchOpen, setIsSearchOpen] = useState(false); // New state for search
//   const searchInputRef = useRef(null);

//   // Scroll detection logic
//   useEffect(() => {
//     const handleScroll = () => {
//       setIsScrolled(window.scrollY > 50);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   // Close search when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (searchInputRef.current && !searchInputRef.current.contains(event.target)) {
//         setIsSearchOpen(false);
//       }
//     };
//     if (isSearchOpen) {
//       document.addEventListener('mousedown', handleClickOutside);
//     }
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, [isSearchOpen]);

//   const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);

//   // Dynamic Classes based on Scroll
//   const navbarBg = isScrolled ? "bg-white shadow-md" : "bg-transparent";
//   const textColor = isScrolled ? "text-gray-700" : "text-white";
//   const hoverColor = isScrolled ? "hover:text-blue-700" : "hover:text-blue-200";
  
//   // Custom Hover Underline Component
//   const NavLink = ({ href, children, isActive = false }) => (
//     <a href={href} className={`relative group ${textColor} ${hoverColor} font-bold text-[15px] uppercase tracking-wide transition-colors duration-300`}>
//       {children}
//       <span className={`absolute -bottom-1 left-0 h-0.5 bg-blue-600 transition-all duration-300 ${isActive ? 'w-full' : 'w-0 group-hover:w-full'}`}></span>
//     </a>
//   );

//   return (
//     <header className={`font-sans w-full fixed top-0 z-50 transition-all duration-300 ${navbarBg}`}>
      
//       {/* 
//       --- Top Utility Bar --- 
//       <div className={`border-b hidden md:block transition-colors duration-300 ${isScrolled ? "border-gray-200 bg-gray-50" : "border-white/10 bg-transparent"}`}>
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className={`flex justify-end h-9 items-center space-x-6 text-xs font-medium uppercase tracking-wide ${isScrolled ? "text-gray-500" : "text-gray-200"}`}>
//             {['Press Releases', 'Our Clients'].map((item) => (
//               <a key={item} href="#" className={`${hoverColor} transition`}>{item}</a>
//             ))}
//             <span className="opacity-50">|</span>
//             {['Become Partner', 'Become Dealer', 'Become Distributor'].map((item) => (
//               <a key={item} href="#" className={`${hoverColor} transition`}>{item}</a>
//             ))}
//           </div>
//         </div>
//       </div>
//       */}

//       {/* --- Main Navigation Bar --- */}
//       <div className="w-full">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="flex justify-between h-20 items-center">
            
//             {/* Logo Section */}
//             <div className="flex-shrink-0 flex items-center cursor-pointer">
//                {/* Replace with your logo */}
//                <a href="#">
//                <img className="h-32 w-auto transition-transform hover:scale-105 duration-300" src="/logo.png" alt="BNM WIPERS" /> 
//                </a>
//             </div>

//             {/* Desktop Menu Links */}
//             <nav className="hidden md:flex space-x-8 items-center h-full">
              
//               {/* Interactive Dropdown: Products */}
//                 <NavLink href="#">Home {' '}</NavLink>
//                 <NavLink href="#products">Products</NavLink>
//                   {/*
//               <div className="relative group h-full flex items-center">
//                 <button className={`flex items-center ${textColor} ${hoverColor} font-bold text-[15px] uppercase tracking-wide transition duration-150 ease-in-out`}>
//                   Products
//                    <ChevronDown className="ml-1 h-4 w-4 group-hover:rotate-180 transition-transform duration-300" /> 
//                 </button>
    
//                 <div className="absolute top-20 left-0 mt-0 w-[600px] bg-white shadow-2xl rounded-b-xl py-6 hidden group-hover:block border-t-4 border-blue-600 animate-fade-in-up origin-top">
//                   <div className="grid grid-cols-2 gap-x-8 gap-y-4 px-6">
//                     <div>
//                       <h4 className="text-blue-700 font-bold mb-3 uppercase text-xs tracking-wider border-b pb-1">Passenger Vehicles</h4>
//                       <ul className="space-y-2">
//                         <li><a href="#" className="block text-sm text-gray-600 hover:text-blue-600 hover:translate-x-1 transition-all duration-200 flex items-center"><ArrowRight size={12} className="mr-2 opacity-0 hover:opacity-100"/> Standard Wipers</a></li>
//                         <li><a href="#" className="block text-sm text-gray-600 hover:text-blue-600 hover:translate-x-1 transition-all duration-200 flex items-center"><ArrowRight size={12} className="mr-2 opacity-0 hover:opacity-100"/> Hybrid Wipers</a></li>
//                         <li><a href="#" className="block text-sm text-gray-600 hover:text-blue-600 hover:translate-x-1 transition-all duration-200 flex items-center"><ArrowRight size={12} className="mr-2 opacity-0 hover:opacity-100"/> Rear Wipers</a></li>
//                       </ul>
//                     </div>
//                     <div>
//                       <h4 className="text-blue-700 font-bold mb-3 uppercase text-xs tracking-wider border-b pb-1">Commercial & Heavy</h4>
//                       <ul className="space-y-2">
//                          <li><a href="#" className="block text-sm text-gray-600 hover:text-blue-600 hover:translate-x-1 transition-all duration-200 flex items-center"><ArrowRight size={12} className="mr-2 opacity-0 hover:opacity-100"/> Truck & Bus Wipers</a></li>
//                          <li><a href="#" className="block text-sm text-gray-600 hover:text-blue-600 hover:translate-x-1 transition-all duration-200 flex items-center"><ArrowRight size={12} className="mr-2 opacity-0 hover:opacity-100"/> Wiper Motors</a></li>
//                          <li><a href="#" className="block text-sm text-gray-600 hover:text-blue-600 hover:translate-x-1 transition-all duration-200 flex items-center"><ArrowRight size={12} className="mr-2 opacity-0 hover:opacity-100"/> Accessories</a></li>
//                       </ul>
//                     </div>
//                   </div>
//                   <div className="bg-gray-50 mt-4 px-6 py-3 text-xs text-gray-500 rounded-b-xl flex justify-between items-center">
//                     <span>New Arrival: Silicone Beam Wipers</span>
//                     <a href="#" className="text-blue-600 font-bold hover:underline">View All Products →</a>
//                   </div>
//                 </div>
//               </div>
//                     */}

//               <NavLink href="#about">About Us</NavLink>
//               {/* <NavLink href="#">News & Media</NavLink> */}
//               {/* <NavLink href="#">Careers</NavLink>  */}
//               <NavLink href="#contact">Contact Us</NavLink>

//               {/* Interactive Search Bar */}
//               <div className="relative flex items-center" ref={searchInputRef}>
//                 <div className={`flex items-center overflow-hidden transition-all duration-300 ease-in-out ${isSearchOpen ? 'w-48 opacity-100' : 'w-0 opacity-0'}`}>
//                   <input 
//                     type="text" 
//                     placeholder="Search products..." 
//                     className="w-full bg-gray-100 text-gray-800 text-sm px-3 py-1 rounded-l focus:outline-none border border-transparent focus:border-blue-500"
//                   />
//                 </div>
//                 {/* <button 
//                   onClick={() => setIsSearchOpen(!isSearchOpen)}
//                   className={`${isScrolled ? 'text-gray-500' : 'text-white'} hover:text-blue-500 transition-colors p-2`}
//                 >
//                   <Search size={22} />
//                 </button> */}
//               </div>

//             </nav>

//             {/* Mobile Menu Button */}
//             <div className="flex md:hidden items-center">
//               <button
//                 onClick={toggleMobileMenu}
//                 className={`${textColor} ${hoverColor} focus:outline-none p-2 transition-transform active:scale-95`}
//               >
//                 {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* --- Mobile Menu with Animation --- */}
//       <div 
//         className={`md:hidden bg-white border-t border-gray-100 shadow-lg absolute w-full overflow-hidden transition-all duration-300 ease-in-out ${isMobileMenuOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'}`}
//       >
//         <div className="px-5 pt-4 pb-8 space-y-4">
//           <a href="#" className="block py-3 text-base font-bold border-b border-gray-100 hover:text-blue-600 hover:pl-2 transition-all">Home</a>
//           <a href="#products" className="block py-3 text-base font-bold border-b border-gray-100 hover:text-blue-600 hover:pl-2 transition-all">Products</a>
//           <a href="#about" className="block py-3 text-base font-bold text-blue-600 border-b border-gray-100 hover:pl-2 transition-all">About us</a>
//           <a href="#contact" className="block py-3 text-base font-bold border-b border-gray-100 hover:text-blue-600 hover:pl-2 transition-all">Contact Us</a>
          
//           {/* Mobile Search */}
//           {/* <div className="pt-4">
//             <div className="flex items-center bg-gray-100 rounded px-3 py-2">
//               <input type="text" placeholder="Search..." className="bg-transparent w-full focus:outline-none text-sm" />
//               <Search size={18} className="text-gray-500" />
//             </div>
//           </div> */}
//         </div>
//       </div>
//     </header>
//   );
// };

// export default Navbar;



import React, { useState, useEffect, useRef } from 'react';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const searchInputRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);

  const closeMenu = () => setIsMobileMenuOpen(false);

  const navbarBg = isScrolled ? "bg-white shadow-md" : "bg-transparent";
  const textColor = isScrolled ? "text-blue-800" : "text-white";
  const hoverColor = isScrolled ? "hover:text-blue-700" : "hover:text-blue-800";

  const NavLink = ({ href, children, isActive = false }) => (
    <a
      href={href}
      className={`relative group ${textColor} ${hoverColor} font-bold text-[15px] uppercase tracking-wide transition-colors duration-300`}
    >
      {children}
      <span
        className={`absolute -bottom-1 left-0 h-0.5 bg-blue-600 transition-all duration-300 ${
          isActive ? 'w-full' : 'w-0 group-hover:w-full'
        }`}
      ></span>
    </a>
  );

  return (
    <header className={`font-sans w-full fixed top-0 z-50 transition-all duration-300 ${navbarBg}`}>
      <div className="w-full">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-20 items-center">

            <div className="flex-shrink-0 flex items-center cursor-pointer">
              <a href="#">
                <img
                  className="h-32 w-auto transition-transform hover:scale-105 duration-300"
                  src="/logo.png"
                  alt="BNM WIPERS"
                />
              </a>
            </div>

            {/* Desktop Menu */}
            <nav className="hidden md:flex space-x-8 items-center h-full">
              <NavLink href="#">Home</NavLink>
              <NavLink href="#products">Products</NavLink>
              <NavLink href="#about">About Us</NavLink>
              <NavLink href="#contact">Contact Us</NavLink>
            <a
              href="https://wa.me/919891451698?text=Hello!%20I%20want%20to%20enquire%20about%20bulk%20wiper%20manufacturing%20and%20custom%20orders."
              target="_blank" rel="noopener noreferrer"
              className="bg-blue-700 hover:bg-blue-800 text-white px-6 py-2 rounded-full text-center transition-all duration-300 hover:scale-105"
            >
              Bulk Order
            </a>
            </nav>

            {/* Mobile Menu Button */}
            <div className="flex md:hidden items-center">
              <button
                onClick={toggleMobileMenu}
                className={`${textColor} ${hoverColor} focus:outline-none p-2 transition-transform active:scale-95`}
              >
                {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
              </button>
            </div>

          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden bg-white border-t border-gray-100 shadow-lg absolute w-full overflow-hidden transition-all duration-300 ease-in-out ${
          isMobileMenuOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-5 pt-4 pb-8 space-y-4">
          <a onClick={closeMenu} href="#" className="block py-3 text-base font-bold border-b hover:text-blue-600 hover:pl-2 transition-all">Home</a>
          <a onClick={closeMenu} href="#products" className="block py-3 text-base font-bold border-b hover:text-blue-600 hover:pl-2 transition-all">Products</a>
          <a onClick={closeMenu} href="#about" className="block py-3 text-base font-bold border-b hover:text-blue-600 hover:pl-2 transition-all">About Us</a>
          <a onClick={closeMenu} href="#contact" className="block py-3 text-base font-bold border-b hover:text-blue-600 hover:pl-2 transition-all">Contact Us</a>
          <div className="block py-3 text-base font-bold border-b hover:text-blue-600 hover:pl-2 transition-all">
            <a href="https://wa.me/919891451698?text=Hello!%20I%20want%20to%20enquire%20about%20bulk%20wiper%20manufacturing%20and%20custom%20orders."
                target="_blank" rel="noopener noreferrer"
                className="bg-blue-700 hover:bg-blue-800 text-white px-6 py-2 rounded-full text-center transition-all duration-300 hover:scale-105"
              >Bulk Order</a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
